<script setup lang="ts"></script>

<template>
  <div class="header-bar">
    <nav class="navbar navbar-expand-md fixed-top header-design">
      <div>
        <img class="scan-logo-size" :src="require('@/assets/img/scan-logo.jpg')" alt="Logo" />
      </div>
      <div class="logo-size window-large-position">
        <img :src="require('@/assets/img/logo.png')" alt="Logo" class="img-position" />
      </div>
    </nav>
  </div>
</template>

<style>
.header-bar {
  border-bottom: solid 10px;
  color: #00368f;
  position: relative;
  width: 100%;
  height: 70px;
  top: 0%;
  display: flex;
  margin-right: 0%;
}

.nav-link.active {
  padding: 0%;
  vertical-align: middle;
}

.navbar.navbar-expand-md.fixed-top.header-design {
  position: relative;
  display: flex;
  height: 100%;
  width: 100%;
  background-color: #ffffff;
  padding-left: 10px;
  padding-right: 10px;
}

.scan-logo-size {
  height: 50px;
  padding: 0%;
  /* cursor: pointer; */
}

.logo-size {
  height: 45px;
  width: auto;
  vertical-align: middle;
}

.nav-item {
  position: relative;
  margin: auto 5px auto 5px;
}

.logo-position {
  text-align: right;
  margin: auto 0 auto auto;
}

.dropdown-position {
  position: relative;
  display: flex;
  text-align: right;
}

.button-design {
  position: relative;
  background-color: #00368f;
  border-color: #00368f;
  border-radius: 1vh;
  height: 40px;
  padding: auto;
  margin-left: 30px;
}

.button-design-scan {
  position: relative;
  background-color: #00368f;
  border-color: #00368f;
  border-radius: 1vh;
  height: 40px;
  padding: auto;
  margin-left: auto;
}

.modal-margin {
  margin: auto auto 1px auto;
  font-weight: bold;
}

.icon-position {
  margin-right: 10px;
}

.window-large-position {
  position: relative;
  display: flex;
  text-align: right;
  margin: auto 0px auto auto;
}

.img-position {
  vertical-align: top;
}
</style>
